import { Block } from 'baseui/block';
import { Card } from 'baseui/card';
import { StyledDivider } from 'baseui/divider';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { jobState } from '../../storage/jobStates';
import JobCardBody from './JobCardBody';
import JobCardHeader from './JobCardHeader';



type Props = {
  id: string
};
function JobCard({ id }: Readonly<Props>) {
  const job = useRecoilValue(jobState(id));

  if (!job) {
    return <></>; // TODO: skeleton
  }

  return (
    <Block>
      <Card
        overrides={{
          Root: {
            style: {
              height: 'calc(100% - 16px)',
              boxSizing: 'border-box',
              borderLeftWidth: '1px',
              borderRightWidth: '1px',
              borderTopWidth: '1px',
              borderBottomWidth: '1px',
            },
          },
          Contents: {
            style: {
              marginTop: 0,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
            },
          },
          Body: {
            style: {
              marginBottom: 0,
            },
          },
        }}
      >
        <JobCardHeader job={job} />
        <StyledDivider
          $size="cell"
          style={{ marginTop: 0, marginBottom: 0 }}
        />
        <JobCardBody job={job} />
      </Card>
    </Block>
  );
}

export default memo(JobCard);
